export const DATA_PARTITION_USER_ART_LIKE = "user-art-like";
export type UserArtLikeKey = {
  PK: typeof DATA_PARTITION_USER_ART_LIKE;
  SK: string;
};

export type UserArtLikeKeyComponents = {
  type: typeof DATA_PARTITION_USER_ART_LIKE;
  artSlug: string;
  slug: string; //userSlug
};

export type UserArtLikeGSI1KeyComponents = {
  type: typeof DATA_PARTITION_USER_ART_LIKE;
  artSlug: string;
  slug: string; //userSlug
};

export type UserArtLikeData = UserArtLikeKeyComponents &
  UserArtLikeGSI1KeyComponents & {
    createdAt: string;
    updatedAt: string;
  };
export type UserArtLikeDBData = UserArtLikeKey & UserArtLikeData;
